import apiCall from "components/Api/api";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import React, { useEffect, useRef, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import FlagIcon from "assets/img/icons/flag.png";
import { useMasterContext } from "provider/MasterProvider";
import { useSafariPackagesContext } from "provider/SharePackagesProvider";

const MarkFlagModal = ({ type }) => {
  const { safariSlug } = useParams();
  const { packSlug } = useParams();
  const { reportContentToggle, commentForFlag, sharedSafariDispatch } = useSharedSafariContext();
  const { flagReasons } = useMasterContext();
  const firstInputRef = useRef(null);
  const [formData, setFormData] = useState({
    report_reason_id: "",
    report_detail: "",
  });
  const [errors, setErrors] = useState({
    report_reason_id: "",
    report_detail: "",
  });

  useEffect(() => {
    if (reportContentToggle && firstInputRef.current) {
      firstInputRef.current.focus(); // Focus the first input field when the modal opens
    }
  }, [reportContentToggle]);

  const handleClose = () => {
    sharedSafariDispatch({
      type: "SET_SHARED_SAFARI_REPORT_CONTENT_TOGGLE",
      payload: false,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { report_reason_id, report_detail } = formData;

    let hasError = false;
    let newErrors = {};
    if (!report_reason_id) {
      newErrors.report_reason_id = "Please select a reason.";
      hasError = true;
    }
    if (!report_detail) {
      newErrors.report_detail = "Please provide details.";
      hasError = true;
    }

    setErrors(newErrors);

    if (hasError) return;
    try {
      // Assuming you would make an API call to report the content
      // You can replace this with an actual API call
      let url = ''
      if (type === 'shareSafariReport') {
        url = `sharesafari/${safariSlug}/flag?share_safari_comment_id=${commentForFlag?.id}`
      } else if (type === 'packageReport') {
        url = `package/${packSlug}/flag?package_comment_id=${commentForFlag?.id}`
      }
      const form = new FormData();
      form.append("report_reason_id", report_reason_id);
      form.append("report_detail", report_detail);
      const response = await apiCall({
        url: url,
        method: "POST",
        data: form,
      });
      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
      const apiData = response.data;
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        const errors = apiData.errors;
        // Dynamically set errors based on the response
        Object.keys(errors).forEach((key) => {
          const errorMessages = errors[key];
          const firstErrorMessage = errorMessages[0];
          // Set the error state for the corresponding field
          setErrors((prevData) => ({
            ...prevData,
            [key]: firstErrorMessage,
          }));
        });
        return;
      }

      // Handle success
      sharedSafariDispatch({
        type: "SET_SHARED_SAFARI_REPORT_CONTENT_TOGGLE",
        payload: false,
      });
      setFormData({
        report_reason_id: "",
        report_detail: "",
      });
      setErrors({
        report_reason_id: "",
        report_detail: "",
      });
    } catch (error) {
      // Handle error (e.g., show an error message)
      console.error("Error reporting content", error);
    }
  };

  return (
    <>
      <Modal
        show={reportContentToggle}
        onHide={handleClose}
        centered
        id="modalFlag"
        backdrop="static"
      >
        <Modal.Header className="flageHeader" closeButton>
          <div className="modal-title fs-5 w-100" id="exampleModalLabel">
            <div className="d-flex align-items-center gap-2">
              <h6 className="fs-5">Report Content</h6>
              <img
                src={FlagIcon}
                alt="Flag"
                className="flag-close-icon"
                style={{ width: "20px", height: "20px", objectFit: "contain" }}
              />
            </div>
            <p className="mt-2 mb-0">
              Please report inappropriate members and/or content to help our
              Trust &amp; Safety team keep our Community safe for everyone.
            </p>
          </div>
        </Modal.Header>

        <Modal.Body className="modal_form">
          <Form
            id="flag-form"
            onSubmit={handleSubmit}
            onKeyDown={handleKeyDown}
          >
            <Row>
              <Col xs={12}>
                <div className="commnets_text">
                  <h6 className="fs-6 fw-semibold">Comment</h6>
                  <p>{commentForFlag?.comment || commentForFlag?.review || commentForFlag?.comment || ""}</p>
                </div>
              </Col>

              <Col xs={12}>
                <Form.Group
                  className="selects w-100 d-flex flex-column mb-3"
                  controlId="reportReason"
                >
                  <Form.Label className="Modal_label">Reason</Form.Label>
                  <Form.Select
                    name="report_reason_id"
                    className="form-select-lg"
                    aria-label="Large select example"
                    value={formData.report_reason_id}
                    onChange={handleChange}
                    ref={firstInputRef}
                  >
                    <option value="">Select Reason</option>
                    {flagReasons?.map((item) => (
                      <option key={item?.value} value={item?.value}>
                        {item?.label}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.report_reason_id && (
                    <p className="text-danger">{errors.report_reason_id}</p>
                  )}
                </Form.Group>
              </Col>

              <Col lg={12} className="mb-2 mt-1">
                <Form.Group controlId="reportDetail" className="textarea mb-3">
                  <Form.Label className="Modal_label">Details</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="report_detail"
                    placeholder="Write Reason in Detail"
                    value={formData.report_detail}
                    onChange={handleChange}
                  />
                  {errors.report_detail && (
                    <p className="text-danger">{errors.report_detail}</p>
                  )}
                </Form.Group>
              </Col>

              <Col xs={12}>
                <div className="btn_report float-end">
                  <div className="btn_report_cance d-flex gap-2">
                    <button
                      type="button"
                      onClick={handleClose}
                      className="close_btns"
                      tabIndex="0"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      variant="primary"
                      className="btns_submit"
                      tabIndex="0"
                    >
                      Report
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MarkFlagModal;
